import { Expose } from "class-transformer";
import { IsArray, IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export default class CreateShopGroupInput {
  @IsString()
  readonly label: string;

  @IsString()
  @IsOptional()
  @Expose({ name: 'image_url' })
  readonly imageUrl?: string | null;

  @Expose({ name: 'is_disabled_for_shop' })
  @IsBoolean()
  @IsOptional()
  readonly isDisabled?: boolean;

  @IsBoolean()
  @IsOptional()
  @Expose({ name: 'is_design' })
  readonly isDesign?: boolean;

  @IsNumber()
  @IsOptional()
  readonly position?: number;

  @IsArray()
  @IsOptional()
  @Expose({ name: 'banners_url' })
  readonly bannersUrl?: string[];

  constructor(init?: CreateShopGroupInput) {
    this.label = init?.label!;
    this.imageUrl = init?.imageUrl;
    this.isDisabled = init?.isDisabled;
    this.isDesign = init?.isDesign;
    this.position = init?.position;
    this.bannersUrl = init?.bannersUrl;
  }
}
